export const HARDWARE_TYPES = [
  {
    value: 'access_points',
    countKey: 'nb_access_points',
    okKey: 'nb_access_points_ok',
    labelKey: 'supervision.hardware.types.access_points',
    navigationLabelKey: 'supervision.hardware.navigation_types.access_points',
    icon: 'fa-solid fa-signal-stream',
    topologyType: 'access_point'
  },
  {
    value: 'switches',
    countKey: 'nb_switches',
    okKey: 'nb_switches_ok',
    labelKey: 'supervision.hardware.types.switches',
    navigationLabelKey: 'supervision.hardware.navigation_types.switches',
    icon: 'fa-solid fa-ethernet',
    topologyType: 'switch'
  },
  {
    value: 'esls',
    countKey: 'nb_esls',
    okKey: 'nb_esls_ok',
    labelKey: 'supervision.hardware.types.esls',
    navigationLabelKey: 'supervision.hardware.navigation_types.esls',
    icon: 'fa-solid fa-barcode-read',
    topologyType: 'esl',
    supportsCompleteDetails: false
  },
  {
    value: 'firewalls',
    countKey: 'nb_firewalls',
    okKey: 'nb_firewalls_ok',
    labelKey: 'supervision.hardware.types.firewalls',
    navigationLabelKey: 'supervision.hardware.navigation_types.firewalls',
    icon: 'fa-solid fa-firewall',
    topologyType: 'firewall'
  },
  {
    value: 'tvs',
    countKey: 'nb_tvs',
    okKey: 'nb_tvs_ok',
    labelKey: 'supervision.hardware.types.tvs',
    navigationLabelKey: 'supervision.hardware.navigation_types.tvs',
    icon: 'fa-solid fa-tv',
    topologyType: 'tv',
    supportsCompleteDetails: false
  },
  {
    value: 'chromecasts',
    countKey: 'nb_chromecasts',
    okKey: 'nb_chromecasts_ok',
    labelKey: 'supervision.hardware.types.chromecasts',
    navigationLabelKey: 'supervision.hardware.navigation_types.chromecasts',
    icon: 'fa-solid fa-screencast',
    topologyType: 'chromecast',
    supportsCompleteDetails: false
  },
  {
    value: 'cctv_cameras',
    countKey: 'nb_cctv_cameras',
    okKey: 'nb_cctv_cameras_ok',
    labelKey: 'supervision.hardware.types.cctv_cameras',
    navigationLabelKey: 'supervision.hardware.navigation_types.cctv_cameras',
    icon: 'fa-solid fa-camera-cctv',
    topologyType: 'cctv_camera'
  },
  {
    value: 'cctv_servers',
    countKey: 'nb_cctv_servers',
    okKey: 'nb_cctv_servers_ok',
    labelKey: 'supervision.hardware.types.cctv_servers',
    navigationLabelKey: 'supervision.hardware.navigation_types.cctv_servers',
    icon: 'fa-solid fa-server',
    topologyType: 'cctv_server'
  },
  {
    value: 'inverters',
    countKey: 'nb_inverters',
    okKey: 'nb_inverters_ok',
    labelKey: 'supervision.hardware.types.inverters',
    navigationLabelKey: 'supervision.hardware.navigation_types.inverters',
    icon: 'fa-solid fa-bolt',
    topologyType: 'inverter'
  }
]

export const getVisibleHardwareTypes = (count = {}) =>
  HARDWARE_TYPES.filter(({ countKey }) => Boolean(count[countKey]))

export const getHardwareTypeConfig = (hardwareType) =>
  HARDWARE_TYPES.find(({ value }) => value === hardwareType) || HARDWARE_TYPES[0]

export const supportsCompleteDetails = (hardwareType) => {
  const config = HARDWARE_TYPES.find(({ value }) => value === hardwareType)
  return Boolean(config && config.supportsCompleteDetails !== false)
}
